import * as tslib_1 from "tslib";
import { Injectable } from '@angular/core';
import { of } from 'rxjs/observable/of';
import { RestService, ExtRestConfig } from '../../common';
var ApiItemService = /** @class */ (function () {
    function ApiItemService(rest, conf) {
        this.rest = rest;
        this.conf = conf;
    }
    ApiItemService.prototype.getItem = function (meta, id) {
        if (id == 0) {
            return of({});
        }
        return this.rest.http.get(this.conf.basePath + meta.url + '/' + id);
    }; // getItem()
    ApiItemService.prototype.save = function (item, meta) {
        // if object has links that means they are already saved.The have to be patched.
        if (item._links) {
            return this.patch(item);
        }
        return this.rest.http.post(this.conf.basePath + meta.url, item);
    }; // save()
    ApiItemService.prototype.delete = function (item) {
        this.rest.deleteWithConfirm(item._links.self.href);
    }; // delete
    ApiItemService.prototype.patch = function (item) {
        return this.rest.http.patch(item._links.self.href, item);
    }; // patch
    ApiItemService = tslib_1.__decorate([
        Injectable(),
        tslib_1.__metadata("design:paramtypes", [RestService, ExtRestConfig])
    ], ApiItemService);
    return ApiItemService;
}()); // class
export { ApiItemService };
//# sourceMappingURL=api-item.service.js.map